<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        06.17
        <br />2016
      </span>
      <span class="tiel">美菜网刘传军获评年度中国双创新闻人物</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/fa8f6eb772593f5672a997c47a60c56f.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        第二十八届中国经济新闻大赛暨2015年度中国创业创新新闻人物颁奖典礼，于6月12日在北京举行。美菜网创始人兼CEO刘传军被评为“2015年度中国创业创新新闻人物”，这项评选反映了大众创业、万众创新热潮的丰硕成果，也体现了经济媒体人物报道的最新成果。
        <br />
        <br />全国人大教科文卫委员会主任委员、清华大学新闻学院院长柳斌杰，全国记协党组书记、常务副主席翟惠生到会讲话并为获奖者颁奖。人民日报原副总编辑张虎生、经济日报原总编辑艾丰、经济日报原总编辑冯并、国家新闻出版广电总局新闻报刊司司长李军、中央网信办网络新闻信息传播局副局长刘冲等有关部门负责同志、新闻界资深人士，获奖作品代表、获奖人物，以及媒体界、企业界代表出席颁奖典礼。
        <br />
        <br />2015年度中国创业创新领军人物推评，侧重“大众创业、万众创新”优秀人物。“大众创业，万众创新”已经上升到国家经济发展新引擎的战略高度，在中国社会的蓬勃兴起的大背景下进行的，旨在深入贯彻新发展理念，营造更好的创新创业环境和氛围，激发大众创业，万众创新的热情和活力。
        <p align="center" style="padding: 40px 0 10px;">
          <img src="https://img-oss.yunshanmeicai.com/cfile/9efdae3cc27ab59adbfcc409518208db.jpg" />
        </p>
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>而美菜就是生鲜移动B2B电商创新的代表。
      </div>
      <div
        class="tet-js"
      >美菜网CEO刘传军表示：“我创办美菜是出于对农村的情怀和对土地的热爱。通过互联网的方式来改变农业、农村和农民，是我的一个夙愿。美菜要做的，就是利用互联网B2B真正砍掉所有的中间环节，实现农户和餐厅的直接交付。”美菜两年将企业规模扩大到数万人，在生鲜B2B领域主打“新鲜低价”的品牌概念。通过构建一套创新独特的企业文化和商业模式，成功占据了国内生鲜电商最大的一块阵地。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜创新一：源头直采
      </div>
      <div
        class="tet-js"
      >源头直采可以保证菜品“新鲜、低价”，是田间到餐厅的直通车。因为取消了中间环节，从而大大缩短了生鲜食材采摘后送到餐厅的时间。这不仅最大程度的保留了菜品的新鲜度，还避免了多梯次批发层层加价，从而保证菜品低价。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜创新二：自建物流冷链体系
      </div>
      <div class="tet-js">美菜自建物流冷链体系，源头直采一站式对接餐厅。因为解决农产品流通环节的话，未来在农产品产业化方面，将会有很多资本投入来刺激农业产业化的发展。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜创新三：农业情怀与“红色”企业文化
      </div>
      <div class="tet-js">
        刘传军有对农民的责任和对改变农民生活的情怀，认为互联网带来了扁平化，也带来了生鲜B2B电商的机遇，借助科技的力量可以让农村变得更好。成立美菜以来，刘传军更是借鉴毛泽东思想在公司内部渗透“红色文化”，是其有别于众多电商企业的独特之处。
        <br />
        <br />在互联网经济与商业文化的大背景下，美菜将率先成为农村电商的践行者，不仅将改变中国几千年来传统农业的贫穷落后的现状，并响应国家“大众创业，万众创新”的经济号召，在生鲜B2B电商领域留下浓墨重彩的一笔！目前，美菜已经和海外市场洽谈合作，几年下来将会累积可观的规模来保证它的竞争力。美菜坚信可以改变传统农业的落后面貌，为农业现代化的发展献上一份力！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
